import { adminRequestsTyped } from "@/api/(requests)/adminTyped";
import type { GetAllCseResponse } from "@/core/types/(api)/cse";

export async function getCseList(): Promise<GetAllCseResponse> {
  return adminRequestsTyped.fetch_all_cse();
}
